export default class Decorater {
    text;
    static CLASS_TYPE_MAP = {
        lint: 'p-topInput__blue',
        ai: 'p-topInput__green',
        kuromoji: 'p-topInput__red',
    };
    constructor(text) {
        this.text = text;
    }
    /**
     *
     * @param targetText
     * @returns
     *
     * 重複する指摘箇所を削除します。
     * 入力エリアのテキストをspanタグで装飾します。
     *
     */
    decorate(errorPoints, targetText) {
        // エスケープ処理用の関数
        const escapeHtml = (str) => str.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        // サロゲートペア文字の文字化け対策
        const getSafeIndex = (text, index, isStart) => {
            if (index > 0 && index < text.length) {
                const prev = text.charCodeAt(index - 1);
                const curr = text.charCodeAt(index);
                // 上位サロゲートと下位サロゲートの間（文字のど真ん中）か判定
                if (prev >= 0xD800 && prev <= 0xDBFF && curr >= 0xDC00 && curr <= 0xDFFF) {
                    // 開始位置なら前へ、終了位置なら後ろへずらして文字を丸ごと包む
                    return isStart ? index - 1 : index + 1;
                }
            }
            return index;
        };
        // インデックス順に確実に処理するためのソート（手前から順に切り出すため）
        const sortedErrors = [...errorPoints].sort((a, b) => a.index - b.index);
        let resultHtml = '';
        let lastProcessedIndex = 0;
        for (const errorPoint of sortedErrors) {
            // サロゲートペア分断を防ぐためにインデックスを補正
            const safeStartIndex = getSafeIndex(targetText, errorPoint.index, true);
            const safeEndIndex = getSafeIndex(targetText, errorPoint.index + errorPoint.range + 1, false);
            // 重複・内包しているエラーポイントのスキップ処理（安全対策）
            if (safeStartIndex < lastProcessedIndex)
                continue;
            // 前回の指摘箇所から、今回の指摘箇所までの「通常のテキスト」をエスケープして結合
            if (safeStartIndex > lastProcessedIndex) {
                resultHtml += escapeHtml(targetText.slice(lastProcessedIndex, safeStartIndex));
            }
            const className = this.getClassName(errorPoint);
            const { tagStart, tagEnd } = this.createTag(className, errorPoint, 0);
            // 装飾用の開始タグを追加（★ここはHTMLとして機能させるためエスケープしない）
            resultHtml += tagStart;
            // 指摘対象のテキスト自体をエスケープして結合
            resultHtml += escapeHtml(targetText.slice(safeStartIndex, safeEndIndex));
            // 装飾用の終了タグを追加（エスケープしない）
            resultHtml += tagEnd;
            // 処理済みインデックスを更新
            lastProcessedIndex = safeEndIndex;
        }
        // 最後の指摘箇所以降の残りのテキストをエスケープして結合
        if (lastProcessedIndex < targetText.length) {
            resultHtml += escapeHtml(targetText.slice(lastProcessedIndex));
        }
        // 改行を <div> で囲む処理
        return resultHtml.split('\n').map((line) => {
            if (line === '')
                return '<div><br></div>';
            return `<div>${line}</div>`;
        }).join('');
    }
    getClassName(errorPoint) {
        return errorPoint.type in Decorater.CLASS_TYPE_MAP
            ? Decorater.CLASS_TYPE_MAP[errorPoint.type]
            : 'p-topInput__red';
    }
    createTag(tagClass, errorPoint, ruleId) {
        // エスケープ関数
        const escapeAttr = (str) => {
            if (str === null || str === undefined)
                return '';
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        };
        // 外部データが入る可能性のある属性値をすべてエスケープ
        const uniqueId = escapeAttr(errorPoint.uniqueId);
        const order = errorPoint.addOrder ? escapeAttr(errorPoint.addOrder.join(' ')) : escapeAttr(errorPoint.order);
        const ruleIdAttr = escapeAttr(ruleId);
        const tagStart = `<span class="${tagClass} ${errorPoint.type} js-point-out-span" data-order="${order}" data-index="${errorPoint.index}" data-rule_idx="${ruleIdAttr}" data-rule_unique_id="${uniqueId}" data-info_type="${errorPoint.type}">`;
        const tagEnd = `</span>`;
        return { tagStart, tagEnd };
    }
}
